// extracted by mini-css-extract-plugin
module.exports = {"page":"KnowledgeBasePage_page__1hC4K"};